import { DerivativeWallet } from "./derivative_wallet";
import { TYPE_NAME_EQUITY_ETC } from "@helpers/constants";

export class EquityETCWallet extends DerivativeWallet {
	public static TypeName: string = TYPE_NAME_EQUITY_ETC;
}
